import React from 'react';
import {
  qualifiesHiResAudioBadge,
  showHiResAudioBadgeForAlbum,
  showHiResAudioBadgeForTrack,
} from '../hooks/useAudioQuality';

const BADGE_SRC = '/images/hi-res-audio-badge.png';

const badgeImg = (height, className, style) => (
  <img
    src={BADGE_SRC}
    alt="Hi-Res Audio"
    height={height}
    width="auto"
    decoding="async"
    draggable={false}
    className={`inline-block align-middle ${className}`.trim()}
    style={{ height, width: 'auto', verticalAlign: 'middle', ...style }}
  />
);

/**
 * Official Hi-Res Audio logo — inline badge only when bit depth / sample rate qualify.
 * @param {number} [height] — 16 track lists / search; 20 album detail headers
 */
export default function HiResAudioBadge({
  bitDepth,
  sampleRate,
  height = 16,
  className = '',
  style = {},
}) {
  if (!qualifiesHiResAudioBadge(bitDepth, sampleRate)) return null;
  return badgeImg(height, className, style);
}

/** Numeric rules, or API `hires` when bit depth / sample rate are absent. */
export function HiResAudioBadgeForTrack({ track, height = 16, className = '' }) {
  if (!showHiResAudioBadgeForTrack(track)) return null;
  return badgeImg(height, className, {});
}

/** Numeric rules, or API `hires` when bit depth / sample rate are absent. */
export function HiResAudioBadgeForAlbum({ album, height = 16, className = '' }) {
  if (!showHiResAudioBadgeForAlbum(album)) return null;
  return badgeImg(height, className, {});
}
